import { useMemo } from "react";

export const useSelectOptions = (
  data = [],
  {
    labelKey,
    valueKey,
    allLabel = "All",
    allValue = 0,
  }
) => {
  return useMemo(() => {
    const options = Array.isArray(data)
      ? data.map((item) => ({
          label: item[labelKey],
          value: item[valueKey],
        }))
      : [];

    return [
      { label: allLabel, value: allValue },
      ...options,
    ];
  }, [data, labelKey, valueKey, allLabel, allValue]);
};
